import React from 'react'
import { Box, Stack } from '@mui/material'

import ReporterEmail from './ReporterEmail'
import ReporterName from './ReporterName'
import ReporterPhoneNumber from './ReporterPhoneNumber'

const ReporterContactInfo: React.FC = () => {
  return (
    <Box
      component="div"
      sx={{
        backgroundColor: '#fbfbfb',
        padding: '10px',
        borderRadius: '5px',
      }}
    >
      <h3>Reporter Contact Information</h3>
      <Stack component="div" spacing={20} flex={1}>
        <ReporterName />
        <ReporterEmail />
        <ReporterPhoneNumber />
      </Stack>
    </Box>
  )
}

export default ReporterContactInfo
